import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowRight, X } from "lucide-react";

export const MobileCta = ({ onNavigate }) => {
    const [visible, setVisible] = useState(false);
    const [dismissed, setDismissed] = useState(false);

    useEffect(() => {
        const onScroll = () => setVisible(window.scrollY > 650);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const show = visible && !dismissed;

    return (
        <AnimatePresence>
            {show && (
                <motion.div
                    data-testid="mobile-sticky-cta"
                    initial={{ y: 80 }}
                    animate={{ y: 0 }}
                    exit={{ y: 80 }}
                    transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                    className="fixed inset-x-0 bottom-0 z-40 lg:hidden"
                >
                    <div className="flex items-stretch bg-vec-green shadow-[0_-4px_20px_rgba(23,34,28,0.28)] pb-safe">
                        <button
                            type="button"
                            data-testid="mobile-sticky-cta-button"
                            onClick={() => onNavigate("#contact")}
                            className="flex-1 inline-flex items-center justify-center gap-2 py-3.5 text-white font-semibold text-sm tracking-wide"
                        >
                            Contact VEC
                            <ArrowRight size={15} aria-hidden="true" />
                        </button>
                        <button
                            type="button"
                            data-testid="mobile-sticky-cta-dismiss"
                            onClick={() => setDismissed(true)}
                            className="px-4 text-white/70 hover:text-white border-l border-white/20"
                            aria-label="Dismiss contact bar"
                        >
                            <X size={16} />
                        </button>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};
